const getEnvironment = () => {
  if (typeof window === "undefined") return process.env.REACT_APP_NODE_ENV

  const hostname = window.location.hostname

  // Map hostnames to environments
  const environmentMap = {
    "dev.propforce.com": "dev",
    "staging.propforce.com": "staging",
    "qa.propforce.com": "qa",
    "zameen.propforce.com": "zameenProduction",
    "bayut.propforce.com": "bayutProduction",
    "training-bayut.propforce.com": "trainingBayutProduction",
    "training-zameen.propforce.com": "trainingZameenProduction",
  }

  return environmentMap[hostname] || process.env.REACT_APP_NODE_ENV
}

export const currentEnvironment = getEnvironment()

export const isDevelopment = currentEnvironment === "development"
export const isStaging = currentEnvironment === "staging"
export const isQA = currentEnvironment === "qa"
export const isProduction = currentEnvironment === "production"
